import { logError } from '@modulis/utils';
import { PopupCookie } from '../dto/popupcookie';

export function cookieInnenforKarantenetid(popupNavn: string): boolean {
  const lkpopupcookie = document.cookie.split('; ').find((row) => row.startsWith('lkpopup'));
  const popupCookieVerdi = decodeURIComponent(lkpopupcookie?.split('=')[1] ?? '');
  const decodedPopupVerdi = atob(popupCookieVerdi);

  try {
    const popupCookie: PopupCookie = popupCookieVerdi ? JSON.parse(decodedPopupVerdi) : {};

    const treff = popupCookie.Liste?.find((e) => {
      return e.popupNavn === popupNavn;
    });

    if (treff) {
      return new Date() <= new Date(treff.utlopstidKarantene);
    }

    return false;
  } catch (err) {
    logError(`Feil ved parsing av 'lkpopup'' cookie`, err);
    return false;
  }
}
